import { FC } from 'react'
import classes from './emptyState.module.scss'

interface EmptyStateProps {
  isLoading?: boolean
  message?: string
  onEnableClick?: () => void
  type?: 'disabled' | 'empty'
}

export const EmptyState: FC<EmptyStateProps> = ({
  isLoading = false,
  message = "You don't have any saved campaign.",
  onEnableClick,
  type = 'empty',
}) => {
  if (isLoading) {
    return (
      <div className={classes.emptyState}>
        <p className={classes.emptyText}>Loading content analyses...</p>
      </div>
    )
  }

  if (type === 'disabled') {
    return (
      <div className={classes.disabledContent}>
        <div className={classes.disabledBody}>
          <div className={classes.disabledIconWrapper}>
            <svg fill="none" height="32" viewBox="0 0 32 32" width="32">
              <path
                clipRule="evenodd"
                d="M15.0859 5.94208C10.0365 5.94208 5.94305 10.0355 5.94305 15.0849C5.94305 20.1344 10.0365 24.2278 15.0859 24.2278C20.1354 24.2278 24.2288 20.1344 24.2288 15.0849C24.2288 10.0355 20.1354 5.94208 15.0859 5.94208ZM3.2002 15.0849C3.2002 8.52064 8.52161 3.19922 15.0859 3.19922C21.6503 3.19922 26.9716 8.52064 26.9716 15.0849C26.9716 17.7073 26.1224 20.1313 24.6839 22.097L28.265 25.678C28.9792 26.3921 28.9792 27.5499 28.265 28.264C27.5509 28.9781 26.3932 28.9781 25.679 28.264L22.0979 24.6829C20.1323 26.1215 17.7083 26.9706 15.0859 26.9706C8.52161 26.9706 3.2002 21.6493 3.2002 15.0849ZM13.6946 10.2749C14.0241 8.76952 16.1676 8.76014 16.5102 10.2626L16.526 10.3319C16.5367 10.379 16.5465 10.4223 16.5571 10.4676C16.938 12.0898 18.2508 13.3293 19.8942 13.6152C21.4649 13.8885 21.4649 16.1434 19.8942 16.4166C18.242 16.7041 16.924 17.9553 16.5511 19.5903L16.5102 19.7693C16.1676 21.2717 14.0241 21.2623 13.6946 19.757L13.661 19.6034C13.3018 17.9625 11.9855 16.702 10.3307 16.4141C8.76275 16.1413 8.76273 13.8905 10.3307 13.6178C11.9798 13.3309 13.2926 12.0781 13.6572 10.4456L13.6819 10.3329L13.6946 10.2749Z"
                fill="black"
                fillRule="evenodd"
              />
            </svg>
          </div>
          <h2 className={classes.disabledTitle}>
            Content Analysis Is Disabled
          </h2>
          <p className={classes.disabledDescription}>
            Enable Content Analysis to analyze social media content performance,
            engagement metrics, and content trends across all platforms.
          </p>
          <button
            className={classes.enableButton}
            onClick={onEnableClick}
            type="button"
          >
            Enable
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className={classes.emptyState}>
      <p className={classes.emptyText}>{message}</p>
    </div>
  )
}
